import { ACTION_SET_TOKENS } from "./names";

/**
 * @param {Object} tokens
 */
function changeTokensInfo(tokens) {
  return {
    type: ACTION_SET_TOKENS,
    payload: tokens,
  };
}

export default {
  changeTokensInfo,
};
